// Largest integer value supported by SQL's int type
export const MAX_SQL_INT = 2147483647
